import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div`
${({ theme }) => css`
  width: 100%;
  background: ${transparentize(0.05, theme.colors.background)};
  padding: 2.4rem;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 1.5rem 0.3rem 1rem 1.5rem;
`}
`;
